import BlockContent from '@sanity/block-content-to-react';
import React, { useEffect, useState } from 'react';
import sanity from '../../sanity.js';
import OnBack from '../Auth/OnBack';
import styles from './privacy.module.scss';

function Privacy() {
    const [privacy, setPrivacy] = useState(false);
    useEffect(() => {
        const getPage = async () => {
            const privacyBlocks = await sanity.General.GetPage(
                'privacy',
                process.env.REACT_APP_COMPANY_ID
            );
            setPrivacy(privacyBlocks);
        };
        getPage();
    }, []);
    return (
        <div>
            <OnBack defaultHref={'/register'} title={privacy.subtitle} />
            <div className={styles.privacy}>
                <div className={styles.content_wrap}>
                    <BlockContent blocks={privacy.body} />
                </div>
            </div>
        </div>
    );
}

export default Privacy;
